import { tokens } from 'src/design-system';

const commonStyleSheet = {
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  justifySpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  ellipses: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  ellipsestext: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  buttonStyle: {
    backgroundColor: tokens.colors.primary,
    color: tokens.colors.bgWhite,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
  },
  header: {
    padding: tokens.spacing.lg,
    border: `1px solid ${tokens.colors.border}`,
    borderRadius: tokens.radius.lg,
    margin: tokens.spacing.md,
  },
  fixedScrollbar: {
    '&::-webkit-scrollbar:vertical': {
      width: '11px',
    },
    '&::-webkit-scrollbar:horizontal': {
      height: '11px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: tokens.radius.lg,
      border: `2px solid ${tokens.colors.bgWhite}`,
      backgroundColor: 'rgba(0, 0, 0, .5)',
    },
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
    },
  },
  anchor: {
    color: tokens.colors.primary,
  },
  checkbox: {
    '& .ant-checkbox-checked .ant-checkbox-inner': {
      backgroundColor: tokens.colors.primary,
      borderColor: tokens.colors.primary,
    },
  },
  footer: {
    marginTop: 100,
    position: 'fixed',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    bottom: 0,
    width: '100%',
    color: tokens.colors.bgWhite,
    height: 80,
    zIndex: 0,
    backgroundColor: '#052857',
  },
  buttons: {
    display: 'flex',
    marginTop: '20px',
    width: '90%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  modal: {
    '& .ant-modal-body': {
      padding: tokens.spacing.ms,
    },
  },
  flexRowDiv: {
    display: 'flex',
    flexDirection: 'row',
  },
  icd: {
    float: 'right',
    fontSize: tokens.fontSize.caption,
    borderRadius: tokens.radius.md,
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
  },
  formItem: {
    '& .ant-form-explain': {
      fontSize: tokens.fontSize.caption,
    },
  },
};

// Intentional visual changes from token consolidation:
// - header.border: #EFEFEF -> #E8E8E8 (tokens.colors.border) - slightly darker gray
// - icd.fontSize: 9px -> 10px (tokens.fontSize.caption) - aligned to token scale
// - buttonStyle.fontSize: '12px' string -> 12 number - no visual change

// Backward compatible: commonStyles accepts theme but uses tokens directly.
// During Phase 3 migration, consumers will switch to design-system mixins.
const commonStyles = (theme: any) => commonStyleSheet;

const buttonStyle = (color: string, backgroundColor: string, border: string) => ({
  color,
  backgroundColor,
  border,
  '&:hover': {
    color,
    backgroundColor,
    border,
  },
  '&:focus': {
    color,
    backgroundColor,
    border,
  },
});

export {
  commonStyles,
  buttonStyle,
  commonStyleSheet,
};
